/**
 * Decorative Elements Randomizer — Daisy Connected Shop
 * Ported from WP theme decorative-randomizer.js.
 * Randomizes animation delays, positions, and colors of background blobs
 * for a unique appearance on each page load.
 */

(function () {
  'use strict';

  var container = document.getElementById('decorative-background');
  if (!container) return;

  var colorPalette = [
    { name: 'honeydew', value: '#d4e3db' },
    { name: 'cream', value: '#fffdd0' },
    { name: 'petal-frost', value: '#ffdbe1' },
    { name: 'lavender', value: '#e6e6fa' }
  ];

  /**
   * Random number in range.
   */
  function randomInRange(min, max) {
    return Math.random() * (max - min) + min;
  }

  /**
   * Shuffle array (Fisher-Yates).
   */
  function shuffleArray(array) {
    var shuffled = array.slice();
    for (var i = shuffled.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = shuffled[i];
      shuffled[i] = shuffled[j];
      shuffled[j] = temp;
    }
    return shuffled;
  }

  /* Shuffle colors for the 4 shape divs */
  var shuffledColors = shuffleArray(colorPalette);

  /* Random colors for the 2 pseudo-elements */
  var beforeColor = colorPalette[Math.floor(Math.random() * colorPalette.length)];
  var afterColor = colorPalette[Math.floor(Math.random() * colorPalette.length)];

  /* Set pseudo-element delays and colors via CSS custom properties */
  container.style.setProperty('--before-delay', randomInRange(0, 10).toFixed(2) + 's');
  container.style.setProperty('--after-delay', randomInRange(0, 10).toFixed(2) + 's');
  container.style.setProperty('--before-color', beforeColor.value);
  container.style.setProperty('--after-color', afterColor.value);

  /* Randomize the 4 shape elements */
  var shapes = [
    document.querySelector('.decorative-shape-1'),
    document.querySelector('.decorative-shape-2'),
    document.querySelector('.decorative-shape-3'),
    document.querySelector('.decorative-shape-4')
  ];

  shapes.forEach(function (shape, index) {
    if (!shape) return;

    /* Randomize animation delay */
    shape.style.animationDelay = randomInRange(0, 10).toFixed(2) + 's';

    /* Apply shuffled color */
    if (shuffledColors[index]) {
      shape.style.background = shuffledColors[index].value;
    }
  });
})();
